export const EDITOR_MODES = {
    VIEW: 'view',
    CREATE_FULCRUM: 'create_fulcrum',
    CREATE_CONNECTION: 'create_connection',
    EDIT_FULCRUM: 'edit_fulcrum',
    EDIT_CONNECTION: 'edit_connection'
};

export const FULCRUM_TYPES = {
    WAYPOINT: 'WAYPOINT',
    ROOM: 'ROOM',
    STAIRS: 'STAIRS',
    ELEVATOR: 'ELEVATOR',
    ENTRANCE: 'ENTRANCE',
    HALL: 'HALL',
    RESTROOM: 'RESTROOM',
    KITCHEN: 'KITCHEN',
    RECEPTION: 'RECEPTION',
    EMERGENCY_EXIT: 'EMERGENCY_EXIT',
    LANDMARK: 'LANDMARK'
};

export const FACING_DIRECTIONS = {
    UP: 'UP',
    RIGHT: 'RIGHT',
    DOWN: 'DOWN',
    LEFT: 'LEFT'
};
